import React from "react";

const formatGBPFromPence = (amountPence) => {
    const amountNumber = Number(amountPence ?? 0);
    const safePence = Number.isFinite(amountNumber) ? Math.round(amountNumber) : 0;
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
    }).format(safePence / 100);
};

// Price breakdown shown once the lead has been submitted. Mirrors the Basket page totals.
const QuotePriceSummary = ({ basket }) => {
    const subtotalPence = Number(basket?.total_amount ?? 0);
    const shippingPence = Number(basket?.shipping_amount ?? 0);

    const rows = [
        { label: "Net Price (excl. VAT)", value: subtotalPence },
        { label: "VAT (20%)", value: Math.round(subtotalPence * 0.2) },
        { label: "Shipping Cost", value: shippingPence },
        { label: "Total (incl. VAT)", value: Math.round(subtotalPence * 1.2) + shippingPence },
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 w-full">
            {rows.map(({ label, value }) => (
                <div key={label} className="p-3 sm:p-4 bg-[#F6F4F3] rounded">
                    <p className="text-gray-500 text-[10px] sm:text-xs uppercase">{label}</p>
                    <p className="text-gray-700 font-semibold text-sm sm:text-base">
                        {formatGBPFromPence(value)}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default QuotePriceSummary;
